import { Bell } from 'lucide-react';
import { firstMvp } from '@/lib/productScope';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BrandLogo from '@/components/atoms/BrandLogo';
import {
  CurrencySheet,
  LanguageSheet,
} from '@/components/molecules/PreferenceSheet';
import { PAGE_PATHS } from '@/routes/const';
import { selectIsMember, useAuthStore } from '@/stores/useAuthStore';
import { lazy, Suspense } from 'react';

const NotificationLink = lazy(() => import('./DemoNotificationLink'));

/** 탭 화면 공통 헤더: 로고 · 언어 · 통화 · 알림 (실행계획 6.5 C-01 #1) */
export default function AppHeader() {
  const isMember = useAuthStore(selectIsMember);

  return (
    <header className="sticky top-[var(--gp-system-offset,0px)] z-30 flex h-16 items-center justify-between bg-gp-cream px-2">
      <Link to={PAGE_PATHS.HOME}>
        <BrandLogo />
      </Link>
      <div className="flex items-center gap-1.5">
        <LanguageSheet />
        <CurrencySheet />
        {firstMvp && isMember && <ActualNotificationLink />}
        {!firstMvp && isMember && (
          <Suspense fallback={null}>
            <NotificationLink />
          </Suspense>
        )}
      </div>
    </header>
  );
}

function ActualNotificationLink() {
  const { t } = useTranslation();
  return (
    <Link
      to={PAGE_PATHS.NOTIFICATIONS}
      className="grid size-11 place-items-center"
      aria-label={t('header.notifications')}
    >
      <Bell className="size-5" aria-hidden="true" />
    </Link>
  );
}
